import { login as loginApi, getUserInfo as getUserInfoApi, logout as logoutApi } from '@/api/modules/auth'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken() || '',
  userInfo: null
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  }
}

const actions = {
  login({ commit }, loginForm) {
    return loginApi(loginForm).then(res => {
      const token = res.data.token
      commit('SET_TOKEN', token)
      setToken(token)
      return res
    })
  },

  getUserInfo({ commit }) {
    return getUserInfoApi().then(res => {
      commit('SET_USER_INFO', res.data)
      return res
    })
  },

  logout({ commit }) {
    return logoutApi().catch(() => {}).finally(() => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', null)
      removeToken()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
